import React, { useContext } from "react";
import { SubUsersPopup } from "../../Users/UsersPopUp/SubUsersPopup";
import { popupcontext } from "../../../context/Popupscontext";
import trans from "../../../utils";
import VehicleUsers from "../../Vehicles/VehiclesTableBody/VehicleUsers";

export default function TableRow({
	value,
	style,
	valuestyle,
	view,
	title,
	onClick,
	setActiveViewId,
  activeViewId
}) {
	let {
		currentUserId,
		setCurrentUserId,
		
		isEditing,
		isDeleting,
		userPopup,
		setuserPopup,
	} = useContext(popupcontext);
	const handleView = (id) => {
		if (view.type === "users") {
			setCurrentUserId(id);
			setuserPopup(false);
		} else if (view.type === "vehicles") {
			setActiveViewId((prev) => (prev === id ? null : id));
		}
	};
  console.log("activeViewId", activeViewId)
	return (
		<div
			className={`fs-14 fw-400 d-flex ${style} table-element position-relative`}
			title={title}
			onClick={onClick}
		>
			<div className={`${valuestyle}`}>{value}</div>
			{view && view.status && (
				<div
					className="text-primary mi-8"
					onClick={() => handleView(view.id)}
					role="button"
				>
					{trans("view")}
				</div>
			)}
			{view?.type === "vehicles" &&
				isEditing === false &&
				isDeleting === false &&
				activeViewId === view.id && ( // only render if this row is active
					<VehicleUsers data={view.data} name={view.name} id={view.id} setActiveViewId={setActiveViewId}/>
				)}
			{view &&
				view.type === "users" &&
				view.id === currentUserId &&
				isEditing === false &&
				isDeleting === false &&
				userPopup === false && (
					<SubUsersPopup
						UserId={currentUserId}
						data={view.data}
						name={view.name}
						id={view.id}
					/>
				)}
		</div>
	);
}
